import React from "react";
import CodeGenarator from "../CodeComponent/codeGenerator";
import CopyClip from "./copyClip";

export default class Main1Component extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let stringCode2 = `     https://unpkg.com/react-inline-calender@latest/dist/index.js`;
    let stringCode1 = `     npm i react-inline-calender --save`;
    let stringCode0 = `
     import React from "react";
     import "bootstrap/dist/css/bootstrap.css";
     import {
       FullCalender
     } from "react-inline-calender";
     class Sample extends React.Component {
       constructor(props) {
         super(props);
         this.state = {
           da: ""
         };
         this.valSetter = this.valSetter.bind(this);
       }
       valSetter(val) {
         this.setState({ da: val });
       }
       render() {
         return (
           <div className="container bg-info m-5 p-5">
             <div className="row">
               <div className="offset-2 col-8">
                 <FullCalender input={this.valSetter}></FullCalender>
               </div>
             </div>
           </div>
         );
       }
     }
      
     export default Sample;`;
    return (
      <div className="main" data-nav="1">
        <h2 id="start-start">Inline calender</h2>
        <p>
          <a href="https://www.npmjs.com/package/moment">
            moment
          </a> and <a href="https://getbootstrap.com/docs/4.3/getting-started/introduction/">
            bootstrap
          </a> have been used to create this component.
        </p>
        <h3 id="cdn">CDN</h3>
        <p>Start use component with CDN</p>
        <div className="container">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                <CopyClip value={stringCode2}></CopyClip>
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode2}></CodeGenarator>
                {/* <code id="code1">
                                    </code> */}
              </div>
            </div>
          </div>
        </div>
        <h3 id="npm">npm</h3>
        <p>Start use component with npm</p>
        <div className="container">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                <CopyClip value={stringCode1}></CopyClip>
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode1}></CodeGenarator>
              </div>
            </div>
          </div>
        </div>
        <h3 id="components">Components</h3>
        <ul>
          <li>InlineCalender</li>
          <li>InlineCalenderVertical</li>
          <li>MonthCalender</li>
          <li>YearCalender</li>
          <li>TenYearCalender</li>
          <li>FullCalende</li>
          <li>FullCalenderVertical</li>
        </ul>
        <h3 id="use">Usage</h3>
        <p>import library and get selected value with input props.</p>
        <div className="container">
          <div className="row ">
            <div className="col-12 col-code-keeper position-relative">
              <div className="clipbord-keeper1">
                {/* <svg className="clipbord-svg" data-codes="0" id="i-clipboard"
                                    title="" data-original-title="Copy to clipboard"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20" height="20"
                                        fill="none" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round"
                                        strokeWidth="2">
                                        <path d="M12 2 L12 6 20 6 20 2 12 2 Z M11 4 L6 4 6 30 26 30 26 4 21 4" />
                                    </svg>
                                    <textarea className="clipbordArea" data-codes="0" cols="auto" rows="auto"></textarea> */}
                <CopyClip value={stringCode0}></CopyClip>
              </div>
              <div className="code-keeper">
                <CodeGenarator code={stringCode0}></CodeGenarator>
                {/* <code id="code0">
                                    </code> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
